import { API, pluralize, buildURL } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";
import { batchUpdateItemStatus } from "./useBatchUpdateItemStatus";
import { parseVersionedIdentifier } from "@src/@redux/utils/identifiers";

type Args = {
  itemIds: string[];
  toSectionId: string;
  createReferences: boolean;
  position?: string;
  insertIndex?: number;
};

const [useDuplicateItems, duplicateItems] = createAsyncAction(
  {
    action: "items/duplicate",
    undo: {
      message: (args: Args, { getState }) => {
        const state = getState(),
          section = state.entities.sections.objects[`${args.toSectionId}-0`],
          kit = state.entities.kits.objects[section?.kitUuid],
          space = state.entities.spaces.objects[kit?.spaceId],
          sameKit = section?.kitUuid === state.navPoint?.kitId,
          portal =
            sameKit && state.navPoint?.portalId
              ? state.entities.portals.objects[state.navPoint.portalId]
              : null,
          count = args.itemIds.length;
        return [
          `${count} ${pluralize("asset", count)} copied to `,
          {
            text: section?.name || "Untitled Section",
            url: buildURL(`/s/${section?.shortId}`, { space, portal }),
          },
        ];
      },
      onResult: (_: unknown, result: { result: { items: string[] } }) => {
        return result.result.items.map(versionedId => parseVersionedIdentifier(versionedId).id);
      },
      performUndo: (_: Args, newItemIds: string[], { dispatch }) => {
        void dispatch(batchUpdateItemStatus({ items: newItemIds, status: "trashed" }));
      },
    },
  },
  async ({ toSectionId, itemIds, createReferences, position, insertIndex: _insertIndex }: Args) => {
    return await API.call<{ items: string[] }>({
      endpoint: "items/duplicate",
      method: "PUT",
      data: {
        uuids: itemIds,
        section_uuid: toSectionId,
        create_references: createReferences,
        ...(position && { position }),
      },
    });
  }
);
export default useDuplicateItems;
export { duplicateItems };
